import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import styles from './styles.module.scss';

import apiBillingCMS from '../../../api/Billing';
import ApiBilling from '../../../api/Billing/billingFL';

import Text from '../../Input/Text';

import Config, { spanish, lang } from '../../../config/config';
import { numberChars } from '../../../utils/format/character_restriction';

const BillingRequest = () => {
  const [content, setContent] = useState(null);
  const [orderId, setOrderId] = useState('');
  const [invalidInvoice, setInvalidInvoice] = useState(false);
  const [invalidCode, setInvalidCode] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true);
  const history = useHistory();

  const formChangeHandler = (e) => {
    switch (e.target.id) {
      case 'orderId':
        setOrderId(parseInt(e.target.value, 10));
        setIsDisabled(e.target.value.length < 1);
        break;
      default:
        setOrderId('');
        setIsDisabled(true);
    }
  };

  const onSubmitForm = async () => {
    const payload = {
      Cliente: Config.api_services.client,
      Pais: 'MEX',
      Ambiente: Config.api_services.environment,
      IdPedido: orderId,
    };

    const resp = await ApiBilling.validateBillling(payload);
    if (resp.Codigo === 200 && resp.InfoFacturacion[0]) {
      if (resp.InfoFacturacion[0]?.EsTimbrado === 1) {
        setInvalidInvoice(true);
        setInvalidCode(false);
      }
      if (resp.InfoFacturacion[0]?.EsPedidoValido === 0) {
        setInvalidCode(true);
        setInvalidInvoice(false);
      }

      if (
        resp.InfoFacturacion[0]?.EsPedidoValido === 1 &&
        resp.InfoFacturacion[0]?.EsTimbrado === 0
      ) {
        setInvalidInvoice(false);
        history.push(`${lang}/billing/${orderId}`);
      }
    }
  };

  useEffect(async () => {
    setContent(await apiBillingCMS.getContent());
  }, []);
  return (
    <div className={styles.container}>
      <h2>{spanish ? content?.TitleSpanish : content?.TitleEnglish}</h2>
      <div className={styles.content}>
        <div>
          <Text
            id="orderId"
            type="text"
            title={
              spanish
                ? content?.OrderNumberSpanish
                : content?.OrderNumberEnglish
            }
            onChange={formChangeHandler}
            error={undefined}
            onKeyPress={numberChars}
            required
          />
        </div>
        <div className={styles.error}>
          {invalidInvoice && (
            <p>{spanish ? content?.ErrorSpanish : content?.ErrorEnglish}</p>
          )}
          {invalidCode && (
            <p>
              {spanish
                ? 'Este número de pedido no existe, por favor verifícalo e intenta de nuevo'
                : 'This order number doesn`t exist, please verify it and try again'}
            </p>
          )}
        </div>
        <button
          type="button"
          className={`btn btn-yellow ${isDisabled ? 'disabled' : ''}`}
          onClick={onSubmitForm}
          disabled={isDisabled}
        >
          {spanish
            ? content?.ContinueButtonSpanish
            : content?.ContinueButtonEnglish}
        </button>
      </div>
    </div>
  );
};

export default BillingRequest;
